// extracted by mini-css-extract-plugin
export var carrierTab = "_54-0";
export var carrierTabActive = "_54-1 _54-0";
export var carrierTabInactive = "_54-2 _54-0";
export var carrierTabLabel = "_54-3";
export var carrierTabLabelActive = "_54-4 _54-3";
export var carrierTabLabelInactive = "_54-5 _54-3";
export var carrierTabPercentage = "_54-6";
export var carrierTabPercentageActive = "_54-7 _54-6";
export var carrierTabPercentageInactive = "_54-8 _54-6";
export var carrierTabWinnable = "_54-9";
export var carrierTabWinnableActive = "_54-a _54-9";
export var carrierTabWinnableInactive = "_54-b _54-9";
export var comparisonContainer = "_54-d";
export var missingRateButton = "_54-n";
export var missingRateButtonActive = "_54-o _54-n";
export var missingRateButtonInactive = "_54-p _54-n";
export var missingRateButtonLabel = "_54-q";
export var missingRateButtonLabelActive = "_54-r _54-q";
export var missingRateButtonLabelInactive = "_54-s _54-q";
export var sidebar = "_54-c";
export var strategyButton = "_54-e";
export var strategyButtonActive = "_54-f _54-e";
export var strategyButtonDescription = "_54-k";
export var strategyButtonDescriptionActive = "_54-l _54-k";
export var strategyButtonDescriptionInactive = "_54-m _54-k";
export var strategyButtonInactive = "_54-g _54-e";
export var strategyButtonLabel = "_54-h";
export var strategyButtonLabelActive = "_54-i _54-h";
export var strategyButtonLabelInactive = "_54-j _54-h";
export var unitToggleButton = "_54-t";
export var unitToggleButtonActive = "_54-u _54-t";
export var unitToggleButtonInactive = "_54-v _54-t";
export var unitToggleButtonLabel = "_54-w";
export var unitToggleButtonLabelActive = "_54-x _54-w";
export var unitToggleButtonLabelInactive = "_54-y _54-w";